import React from 'react';

const Icon = ({ name, size = 24, color = 'currentColor' }) => {
    const pluginUrl = window.careld_ajax_obj?.plugin_url || '/wp-content/plugins/carelabel-studio-1.0.2/';
    const spriteUrl = `${pluginUrl}assets/sprite.svg`;

    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={`icon icon-${name}`}
        >
            <use xlinkHref={`${spriteUrl}#${name}`} />
        </svg>
    );
};

export default Icon;